export default __webpack_public_path__ + "static/media/DS-DIGII.67d08007.TTF";